import { NotificationManager } from 'react-notifications';
import ApiRequestService from '../component/ApiRequestService';



export default async function restoreQuestionBankHandler (payload) {
    try{
        let restoreResp = await ApiRequestService({
            method: 'post',
            url: '/restoreQuestionBank',
            data: payload
        });

        if(restoreResp.data !== undefined && restoreResp.data !== null){
            if(restoreResp.data.status === 1){
                NotificationManager.error("Error Restoring Data -"+restoreResp.data.message,"Error",5000);
            }else{
                NotificationManager.success(" Data Restored","Success",5000);
            }
        }else{
            NotificationManager.error("Error Restoring Data","Error",5000);
        }

    }catch(err){
        console.error('ERROR : ', err);
        NotificationManager.error(err, 'ERROR', 3000);
    }
    
    
}